import { CONTACT_FIELD_CODES } from "src/core/constants/contact";
import { EditContactFieldsValues } from "src/core/forms/contact/editContact.schema";
import { DataType } from "src/core/gql/graphql";
import { Contact, Owner, UpdateContactVariables } from "src/core/types/contact";

export const buildUpdateContactVariables = (
  customerFolderId: string, // Doit être celui qui provient de currentCustomerFolder
  formData: EditContactFieldsValues,
  contactPerson: Contact | null,
  owner: Owner | null
): UpdateContactVariables => {
  const variables: UpdateContactVariables = {
    customerFolderId,
    customerFolderId_2: customerFolderId,
    userId: formData.expertComptable || "",
    inputValues: [],
    contactPersonId: contactPerson?.id || "",
  };

  const hasContactFields = Boolean(
    formData.prenom || formData.nom || formData.email || formData.telephone
  );

  if (hasContactFields) {
    variables.mergeContactPerson = true;
    variables.inputValues = makeContactInputValues(formData);
  }

  if (!hasContactFields && contactPerson) {
    variables.deleteContactPerson = true;
    variables.contactPersonId = contactPerson.id;
  }

  if (formData.expertComptable && formData.expertComptable !== "none") {
    variables.setOwner = true;
    variables.customerFolderId = customerFolderId;
    variables.userId = formData.expertComptable;
  }

  if ((!formData.expertComptable || formData.expertComptable === "none") && owner) {
    variables.removeOwner = true;
    variables.customerFolderId_2 = customerFolderId;
  }

  return variables;
};
export const makeContactInputValues = (formData: EditContactFieldsValues) => {
  const contactFields: { key: "prenom" | "nom" | "email" | "telephone"; code: string }[] = [
    { key: "prenom", code: CONTACT_FIELD_CODES.firstName },
    { key: "nom", code: CONTACT_FIELD_CODES.lastName },
    { key: "email", code: CONTACT_FIELD_CODES.email },
    { key: "telephone", code: CONTACT_FIELD_CODES.phone },
  ];

  return contactFields.map(({ key, code }) => {
    const value = formData[key];

    return value
      ? { fieldCode: code, value: value as string, dataType: DataType.String }
      : { fieldCode: code, dataType: DataType.String };
  });
};
